import * as THREE from 'three';
import { gsap, CSSPlugin } from 'gsap/all';
import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment';
import autoBind from 'auto-bind';
import Bubble from 'components/Bubble/Bubble';
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";
import TEXTURE from './lake.jpg';
import {GUI} from "dat.gui";
import bubble from "components/Bubble/Bubble";

gsap.registerPlugin(CSSPlugin);
const SCENE_SELECTOR = 'canvas.webgl';

class App {
  clock = new THREE.Clock();

  scene = new THREE.Scene();

  canvas = document.querySelector(SCENE_SELECTOR);

  renderer = new THREE.WebGLRenderer({
    canvas: this.canvas,
    antialias: true,
  });

  camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight);

  raycaster = new THREE.Raycaster();

  mouse = new THREE.Vector2();

  loader = document.querySelector('#loader');


  constructor() {
    autoBind(this);
    this.setUpCamera();

    this.onResize();
    window.addEventListener('resize', this.onResize);

    this.addGui()
    this.setUpScene().then();
    window.addEventListener('pointermove', this.onMouseMove);
    this.tick();
  }

  setUpCamera() {
    this.scene.add(this.camera);
    this.controls = new OrbitControls(this.camera, this.renderer.domElement);
  }

  async setUpScene() {
    this.scene.background = new THREE.TextureLoader().load(TEXTURE);

    this.environment = new RoomEnvironment();
    this.pmremGenerator = new THREE.PMREMGenerator(this.renderer);

    this.scene.environment = this.pmremGenerator.fromScene(this.environment).texture;

    this.resetBubble()

    this.addInsideBubble()
    this.addLights();

    this.renderer.shadowMap.enabled = true;
  }

  resetBubble() {
    if (this.bubble) {
      window.gui.destroy()
      this.addGui()

      this.scene.remove(this.bubble)
      delete this.bubble
    }

    this.bubble = new Bubble();
    this.bubble.position.set(0, 0, -6);
    this.scene.add(this.bubble);
  }

  tick() {
    this.inside.rotation.z += 0.01
    this.inside.rotation.y += 0.01
    this.inside.rotation.x += 0.01
    this.raycaster.setFromCamera(this.mouse, this.camera);
    const elapsedTime = this.clock.getElapsedTime();

    this.bubble?.tick(elapsedTime, true);

    requestAnimationFrame(this.tick);

    this.controls.update()

    this.renderer.render(this.scene, this.camera);
  }

  onResize() {
    this.canvas.width = window.innerWidth;
    this.canvas.height = window.innerHeight;

    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.renderer.setSize(window.innerWidth, window.innerHeight);

    this.camera.updateProjectionMatrix();
  }

  onMouseMove(evt) {
    evt.preventDefault();
    const array = this.getMousePosition(evt.clientX, evt.clientY);
    this.mouse.fromArray(array);

    const intersects = this.getIntersect(this.mouse, this.bubble);

    if (intersects.length && intersects[0].point) {
      this.bubble.intersectPoint(intersects[0].point);
    } else this.bubble.cancelIntersection();
  }

  getMousePosition(x, y) {
    const rect = this.canvas.getBoundingClientRect();
    return [(x - rect.left) / rect.width, (y - rect.top) / rect.height];
  }

  getIntersect(point, object) {
    this.mouse.set((point.x * 2) - 1, -(point.y * 2) + 1);
    this.raycaster.setFromCamera(this.mouse, this.camera);
    return this.raycaster.intersectObject(object, true);
  }

  addLights() {
    this.directionalLight = new THREE.DirectionalLight(0xfff2f4, 20);
    this.directionalLight.position.set(1, 1, 0.5);
    this.scene.add(this.directionalLight);

    this.ambientLight = new THREE.AmbientLight(0xffffff, 0.75);
    this.scene.add(this.ambientLight);
  }

  addInsideBubble() {
    this.inside = new THREE.Group();
    this.inside.position.set(0,0,-6)

    const box = new THREE.Mesh(new THREE.TorusKnotGeometry( 0.9, 0.05, 100, 16 ), new THREE.MeshNormalMaterial());

    const ball = new THREE.Mesh(new THREE.SphereGeometry(0.1, 32,32), new THREE.MeshNormalMaterial())
    ball.position.set(0.2, 0.2, 0.2)

    this.inside.add(ball)
    this.inside.add(box)

    this.scene.add(this.inside)
  }

  addGui() {
    window.gui = new GUI()
    window.gui.add(this, 'resetBubble')
  }
}

export default App;
